// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateSubscriptionPrice_cancelButton__3rbpv"};